import GranularSynth from './GranularSynth.js';
export default GranularSynth;